import React from 'react';
import Sidebar from './Sidebar';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="layout">
    <Sidebar />
    <div className="content">{children}</div>
  </div>
);

export default Layout;
